/**
 * Attempts to parse a string as JSON.
 *
 * @export
 * @param {string} jsonString
 * @returns {T}
 */
export default function tryParseJSON(jsonString) {
    try {
        const o = JSON.parse(jsonString);
        if (o && typeof o === 'object') {
            return o;
        }
    } catch (e) {
        console.warn('Unable to parse json string: ', jsonString);
    }

    return JSON.parse('[]');
}
